<template>
  <!-- 我的推荐 -->
  <div class="container">
    <Title-b :title="$t('Side.Myrecommendation')" />
    <p class="p2">{{$t('PromotionCenter.total')}}</p>
    <p class="p3">{{ AllCount }}</p>
    <div>
      <Table border :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="AgentType">
          <span v-if="row.deliveryType == 1">{{$t('PromotionCenter.Franchisee')}}</span>
          <span v-else-if="row.deliveryType == 2">{{$t('PromotionCenter.Agent')}}</span>
          <span v-else>{{$t('PromotionCenter.OrdinaryUsers')}}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button @click="show(row.id,row.username)" type="success" size="small" v-if="Rem == 1 && row.deliveryType == 2">{{$t('PromotionCenter.ViewUsers')}}({{row.childrenCount}})</Button>
          <Button @click="setAgent(row.id)" type="primary" size="small" v-if="Rem == 1 && row.deliveryType != 1 && row.deliveryType != 2">{{$t('PromotionCenter.SetAgent')}}</Button>
        </template>
      </Table>
      <Page :total="AllCount" :current="pageNo" :page-size="pageSize" @on-change="onpage" show-total show-elevator class="page"/>
    </div>
    <r-mask :title="'查看' + this.checkUserName +'的用户'" :isShowModal="viewUser" @closeMask="viewUser = false">
      <Table border :columns="columns2" :data="userData">
        <template slot-scope="{ row }" slot="AgentType">
          <span v-if="row.deliveryType == 1">{{$t('PromotionCenter.Franchisee')}}</span>
          <span v-else-if="row.deliveryType == 2">{{$t('PromotionCenter.Agent')}}</span>
          <span v-else>{{$t('PromotionCenter.OrdinaryUsers')}}</span>
        </template>
      </Table>
      <Page :total="AllCount2" :current="pageNo2" :page-size="pageSize2" @on-change="onpage2" show-total show-elevator class="page"/>
    </r-mask>
    <!-- 设置为代理人对话框 -->
    <Modal v-model="handelModal" title="设置代理人" @on-ok="commitAgent">
      <p>{{$t('PromotionCenter.remind')}}</p>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      pageNo:1,
      AllCount:0,
      pageSize:10,
      pageNo2:1,
      AllCount2:0,
      pageSize2:10,
      Rem: 0,
      viewUser: false,
      userData: [],
      handelModal: false,
      userId: 0,
      checkUserName: "",
      columns: [
        { title: this.$t('PromotionCenter.UserMC'), key: 'username', align: 'center',},
        { title: this.$t('PromotionCenter.AgentName'), key: 'username2', align: 'center',},
        { title: this.$t('Home.Email'), key: 'email', align: 'center',},
        { title: this.$t('Personal.Tel'), key: 'mobile', align: 'center', },
        { title: this.$t('PromotionCenter.AgentType'), slot: 'AgentType', align: 'center', width: 120 },
        { title: this.$t('PromotionCenter.Userzc'), key: 'reg_date', align: 'center',width: 160 },
        { title: this.$t('PromotionCenter.RegType'), key: 'zc_type', align: 'center', width: 120 },
        { title: this.$t('PromotionCenter.operation'), slot: 'action', align: 'center', width: 120 }
      ],
      columns2: [
        { title: this.$t('PromotionCenter.UserMC'), key: 'username', align: 'center',},
        { title: this.$t('Home.Email'), key: 'email', align: 'center',},
        { title: this.$t('Personal.Tel'), key: 'mobile', align: 'center', },
        { title: this.$t('PromotionCenter.AgentType'), slot: 'AgentType', align: 'center', width: 120 },
        { title: this.$t('PromotionCenter.Userzc'), key: 'reg_date', align: 'center',width: 160 },
        { title: this.$t('PromotionCenter.RegType'), key: 'zc_type', align: 'center', width: 120 }
      ],
    };
  },
  created() {
    this.getDataList()
    this.getUserType()
  },
  methods: {
    // 获取当前用户身份
    getUserType() {
      let params = { member: localStorage.getItem("userID") };
      this.$post('/getUserInfo',params).then((res) => {
        if(res.data.State) {
          if(res.data.ReturnJson2 == "1") {
            this.columns = this.columns.filter(col => col.key !== "username")
          } else {
            this.columns = this.columns.filter(col => col.key !== "username2")
          }
        }
      })
    },

    //设置代理人
    setAgent(id) {
      this.userId = id
      this.handelModal = true
    },
    commitAgent() {
      let JsonData = {
        MemberId: localStorage.getItem("userID"),
        SetAgentMemberId: this.userId
      }
      this.$post('/SetAgentMember',JsonData).then((res) => {
        if(res.data.State) {
          this.getDataList()
          this.$Message.success("操作成功")
        } else {
          this.$Message.error(res.MsgText)
        }
      })
    },

    // 获取列表数据
    getDataList() {
      let JsonData = {
        MemberId: localStorage.getItem("userID"),
        pageIndex: this.pageNo,
        limit: this.pageSize,   // 第几页
      }
      this.$post('/GetAgentList', JsonData).then((res) => {
        if(res.data.State) {
          this.Rem = parseInt(res.data.Rem)
          this.tableData = JSON.parse(res.data.ReturnJson);
          this.AllCount = parseInt(res.data.MsgText);
        }
      })
    },
    onpage(pageNo){
      this.pageNo = pageNo;
      this.getDataList();
    },
    onpage2(pageNo2){
      this.pageNo2 = pageNo2;
      this.getUserList();
    },

    // 查看用户
    show(id,username) {
      this.checkUserName = username
      this.getUserList(id)
    },
    getUserList(id) {
      let JsonData = {
        MemberId: id,
        pageIndex: this.pageNo2, // 每页条数
        limit: this.pageSize2,   // 第几页
      }
      this.$post('/GetAgentList', JsonData).then((res) => {
        if(res.data.State) {
          this.userData = JSON.parse(res.data.ReturnJson);
          this.AllCount2 = parseInt(res.data.MsgText);
          this.viewUser = true
        } else {
          this.$Message.error(res.MsgText)
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 1069px;
  height: 700px;
  background: #fff;
  border-radius: 5px;
  padding: 19px 17px;
  .p2 {
    color: #69b1d7;
    font-size: 20px;
    margin: 0 0 0 436px;
  }
  .p3 {
    @include color($_color);
    margin: 0 0 0 510px;
    font-weight: bold;
    font-size: 30px;
  }
  .page {
    margin-top: 10px;
    text-align: center;
  }
}

/deep/.modal-bag .modal-content {
  width: 70% !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/view/extension/Myrecommendation.vue